$(function(){
    $('.b-successful-projects__items').each(function(){
        var slider = $(this),
            settings = {
            slidesToShow: 4,
            arrows: true,
            dots: false,
            swipeToSlide: true,
            touchThreshold: 10,
            infinite: false,
            prevArrow:'<div class="b-slider-arrows__prev"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
            nextArrow:'<div class="b-slider-arrows__next"><svg width="20" height="34" viewBox="0 0 20 34" xmlns="http://www.w3.org/2000/svg"><path d="M16.5859 33.4142L0.171665 17L16.5859 0.585788L19.4143 3.41422L5.82852 17L19.4143 30.5858L16.5859 33.4142Z"></path></svg></div>',
                responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    },
                }
            ]
        };
        slider.slick(settings).on('setPosition', function (event, slick) {
            slick.$slides.css('height', 'auto');
            setTimeout(() => {
                slick.$slides.css('height', slick.$slideTrack.height() + 'px');
            }, 0);
        });;
        $(window).on('resize', function() {
            if( $(window).width() > 1024 && !slider.hasClass('slick-initialized')) {
                slider.slick(settings);
            }
        });
    })
});